const m = (n) => `$${Number(n || 0).toFixed(2)}`;
const pct = (r) => `${(Number(r || 0) * 100).toFixed(4).replace(/\.?0+$/, "")}%`;

export function PriceBreakdown({ data, className = "" }) {
  if (!data) return null;
  const sub = data.subtotal;
  const tax = data.tax_amount || 0;
  const total = data.total_price ?? data.grand_total ?? 0;
  const dep = data.deposit_amount || 0;
  const bal = data.balance_amount || 0;
  const label = data.tax_label || "Texas Sales Tax";
  const disc = data.discount_amount || 0;
  const origSub = sub != null ? Number(sub) + Number(disc) : null;
  return (
    <div className={`text-sm text-[#635B52] space-y-1.5 ${className}`} data-testid="price-breakdown">
      {sub != null && (
        <div className="flex justify-between"><span>Subtotal</span><span className="text-[#2C2621]">{m(disc > 0 ? origSub : sub)}</span></div>
      )}
      {disc > 0 && (
        <div className="flex justify-between"><span>Discount{data.discount_code ? ` (${data.discount_code})` : ""}</span><span className="text-green-700" data-testid="pb-discount">−{m(disc)}</span></div>
      )}
      {tax > 0 && (
        <div className="flex justify-between"><span>{label} ({pct(data.tax_rate)})</span><span className="text-[#2C2621]" data-testid="pb-tax">{m(tax)}</span></div>
      )}
      <div className="flex justify-between border-t border-[#E6DEC3] pt-1.5 font-semibold text-base">
        <span className="text-[#2C2621]">Total</span><span className="text-[#2C2621]" data-testid="pb-total">{m(total)}</span>
      </div>
      {(dep > 0 || bal > 0) && (
        <>
          <div className="flex justify-between"><span>50% deposit</span><span className="text-[#B87333]" data-testid="pb-deposit">{m(dep)}</span></div>
          <div className="flex justify-between"><span>Remaining balance</span><span className="text-[#2C2621]" data-testid="pb-balance">{m(bal)}</span></div>
        </>
      )}
    </div>
  );
}
